import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import {  DateRange, Bookmarks, ExitToApp, CalendarToday  } from "@material-ui/icons/";
// core components
import Navbar from "components/Navbars/Navbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import FixedPlugin from "components/FixedPlugin/FixedPlugin.js";
import styles from "assets/jss/material-dashboard-react/layouts/adminStyle.js";

import bgImage from "assets/img/sidebar-2.jpg";
import logo from "assets/img/logo2.png";

import Request from "views/Meeting/Request.js";
import Agenda from "views/Meeting/Agenda.js";
import Home from "views/Meeting/Home";
import MyMeeting from "views/Meeting/MyMeeting";
import Accept from "views/Meeting/Accept";
import Goto from "views/Meeting/Goto";
import LogoutPage from "views/UserProfile/LogoutPage.js";

let ps;

const routes = [
    {
      name: "ปฏิทินการประชุม",
      icon: DateRange,
      component: Home,
      layout: "/meeting",
      path: "/index",
    },
    {
      name: "จองห้องประชุม",
      icon: Bookmarks,
      component: Request,
      layout: "/meeting",
      path: "/request",
    },
    {
      name: "รายงานการประชุม",
      icon: Bookmarks,
      component: Agenda,
      layout: "/meeting",
      path: "/agenda",
    },
    {
        name: "ตารางประชุมของฉัน",
        icon: CalendarToday,
        component: MyMeeting,
        layout: "/meeting",
        path: "/me",
    },
    {
      name: "ออกจากระบบ",
      icon: ExitToApp,
      component: LogoutPage,
      layout: "/auth",
      path: "/logout",
    },
   
];

const switchRoutes = (
    <Switch>

    {routes.map((prop, key) => {
     
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      
      return null;
    })}
        <Route path="/meeting/accept/:AttendeeID" component={Accept} />
        <Route path="/meeting/id/:MeetingID" component={Goto} />
    <Redirect from="/meeting" to="/meeting/index" />
  </Switch>
);

const useStyles = makeStyles(styles);

export default function Meeting({ ...rest }) {
  // styles
  const classes = useStyles();
  // ref to help us initialize PerfectScrollbar on windows devices
  const mainPanel = React.createRef();
  // states and functions
  const [image, setImage] = React.useState(bgImage);
  const [color, setColor] = React.useState("blue");
  const [fixedClasses, setFixedClasses] = React.useState("dropdown show");
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const handleImageClick = image => {
    setImage(image);
  };
  const handleColorClick = color => {
    setColor(color);
  };
  const handleFixedClick = () => {
    if (fixedClasses === "dropdown") {
      setFixedClasses("dropdown show");
    } else {
      setFixedClasses("dropdown");
    }
  };
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const getRoute = () => {
    return window.location.pathname !== "/admin/maps";
  };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };
  // initialize and destroy the PerfectScrollbar plugin
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);
    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  }, [mainPanel]);
  return (
    <div className={classes.wrapper}>
      <Sidebar
        routes={routes}
        logoText={"ระบบจองห้องประชุม"}
        logo={logo}
        image={image}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={color}
        {...rest}
      />
      <div className={classes.mainPanel} ref={mainPanel}>
        <Navbar
          routes={routes}
          handleDrawerToggle={handleDrawerToggle}
          {...rest}
        />
        {/* On the /maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
        {getRoute() ? (
          <div className={classes.content}>
            <div className={classes.container}>{switchRoutes}</div>
          </div>
        ) : (
          <div className={classes.map}>{switchRoutes}</div>
        )}
        {getRoute() ? <Footer /> : null}
        {/* <FixedPlugin
          handleImageClick={handleImageClick}
          handleColorClick={handleColorClick}
          bgColor={color}
          bgImage={image}
          handleFixedClick={handleFixedClick}
          fixedClasses={fixedClasses}
        /> */}
      </div>
    </div>
  );
}
